/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name BarNarrow
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE5LjUgMTFoLTE1YTEgMSAwIDEwMCAyaDE1YTEgMSAwIDEwMC0ybS0xNS0xLjVhMi41IDIuNSAwIDAwMCA1aDE1YTIuNSAyLjUgMCAwMDAtNXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:bar-narrow
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconBarNarrow = createFondueIcon('BarNarrow', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M19.5 11h-15a1 1 0 100 2h15a1 1 0 100-2m-15-1.5a2.5 2.5 0 000 5h15a2.5 2.5 0 000-5z","clip-rule":"evenodd"}]]);
